import CustomerInfo from '../CustomerInfo/CustomerInfo';
import { ICartWorkflowWizardStep } from './CartWorkflowWizard.types';
import useValidateCustomerInfoPage from '../Hooks/CustomerInfo/ValidateCustomerInfoPageHook';
import InternetOrderNextSteps from '../NextSteps/InternetOrderNextSteps';

const useInternetOrderCartWorkflow = (): ICartWorkflowWizardStep[] => {
    const customerInfoStep: ICartWorkflowWizardStep = {
        title: 'Personal Info',
        proceedText: 'Submit',
        validationHook: useValidateCustomerInfoPage,
        component: (
            <CustomerInfo
                creditCheckFailureFollowUpTitle="You're almost there!"
                creditCheckFailureFollowUpMessage='Please provide a good phone number to contact you, and someone will get back to you shortly.'
            />
        ),
        hideSummary: true,
        wrapped: true
    };

    const nextStepsStep: ICartWorkflowWizardStep = {
        title: 'Next Steps',
        component: <InternetOrderNextSteps />,
        hideSummary: true,
        wrapped: true
    };

    return [customerInfoStep, nextStepsStep];
};

export default useInternetOrderCartWorkflow;
